import { Forms, IntegratorDetail, SelectedAccount } from '@types';

export interface UserInputState {
	acceptMasterOrVisaCards?: boolean;
	acceptedTermsAndConditionsBank?: boolean;
	selectedAccount?: SelectedAccount;
	solutionIntegrated?: boolean;
	selectedIntegrator?: IntegratorDetail;
	forms?: Forms;
}
export const userInputActions = {
	saveUserInput: '@userInput/saveUserInput',
	saveCorporateDataFormInput: '@userInput/saveCorporateDataFormInput',
	saveIntegratorDataFormInput: '@userInput/saveIntegratorDataFormInput',
	saveCorporateDataFormIsValidInput: '@userInput/saveCorporateDataFormIsValidInput',
	saveIntegratorDataFormIsValidInput: '@userInput/saveIntegratorDataFormIsValidInput',
	clearUserInput: '@userInput/clearUserInput',
	clearIntegratorFormInput: '@userInput/clearIntegratorFormInput',
};
